import '/opt/build/repo/node_modules/storybook-addon-react-router-v6/dist/manager.mjs';